export enum PaymentProviders {
  STRIPE = 'stripe',
  PAYPAL = 'paypal'
}
